import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Responsive from 'react-responsive';
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from '../Dropdown';
import theme from '../../../theme';
import Flex from '../Flex';
import { DotsVerticalIcon } from '../Icon';

const Wrapper = styled(Flex)`
  a.button {
      border-radius: 0;
      margin-left: -1px;
      //&:first-child {
      //  border-top-left-radius: 5px;
      //  border-bottom-left-radius: 5px;
      //}
      //&:last-child {
      //  border-top-right-radius: 5px;
      //  border-bottom-right-radius: 5px;
      //}
   }
  @media (max-width: ${theme.breakpoints.desktopLarge}) {
     a.button {
      padding-left: 0;
      padding-right: 0;
      white-space: nowrap;
     }
  }
`;

const ButtonGroup = ({ children, background, ...otherProps }) => (
  <Wrapper {...otherProps}>

    <Responsive maxWidth={theme.breakpoints.desktopLarge}>
      <Dropdown background={background} pullRight>
        <DropdownTrigger>
          <DotsVerticalIcon />
        </DropdownTrigger>
        <DropdownContent>
          {children}
        </DropdownContent>
      </Dropdown>
    </Responsive>

    <Responsive minWidth={theme.breakpoints.desktopLarge}>
      {children}
    </Responsive>

  </Wrapper>
);
ButtonGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  background: PropTypes.string,
};
ButtonGroup.defaultProps = {
  children: null,
  background: theme.colors.white,
};

export default ButtonGroup;
